// Components
import mapboxgl from 'mapbox-gl'
import { useControl } from 'react-map-gl/mapbox'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
// Estils
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

const ControlGeocoder = ({ accessToken, position = 'top-left' }) => {
	useControl(
		() =>
			new MapboxGeocoder({
				accessToken,
				mapboxgl,
				marker: false,
				countries: 'es',
			}),
		{
			position: position,
		},
	)
	return null
}

export default ControlGeocoder
